import routes from './routes/marketing.routes';
import ModuleBase from '../../classes/ModuleBase';


export default new ModuleBase({
    name: 'Marketing',
    routes: routes,
});